// Application Constants

// Routes
export const ADMIN_ROUTE_APPLICATIONS = "applications";
export const ADMIN_ROUTE_APPLICATIONS_VIEW = `${ADMIN_ROUTE_APPLICATIONS}/view`;
export const ADMIN_ROUTE_APPLICATIONS_FORM = `${ADMIN_ROUTE_APPLICATIONS}/form`;
